export class Alfatron {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.0.6';
        this.power = false;
        this.videoOutputs = Array(17).fill('1');
        this.connectStatusInputs = Array(17).fill(true);
        this.connectStatusOutputs = Array(17).fill(true);
        this.numberVideoInputs = 4;
        this.numberVideoOutputs = 4;
        this.masterMute = false;
        this.masterVolume = 50;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\/\^Version;/i,
                callback: (match) => {
                    this.socket.send(`V${this.firmwareVersion}`);
                },
            },
            {
                name: 'getConnectStatus',
                regExp: /%(9971|9972)\./i,
                callback: (match) => {
                    let signalList = match[1] === '9971' ? 'In ' : 'Out ';
                    let connectList = 'Connect ';
                    const maxItems = match[1] === '9971' ? this.numberVideoInputs : this.numberVideoOutputs;
                    const dataArray = match[1] === '9971' ? this.connectStatusInputs : this.connectStatusOutputs;
                    for (let i = 0; i < maxItems; i++) {
                        signalList += '${i}'.padStart(2, '0');
                        connectList += dataArray[i] ? 'Y' : 'N';
                        if (i < maxItems - 1) {
                            signalList += ' ';
                            connectList += ' ';
                        }
                    }
                    this.socket.send(signalList);
                    this.socket.send(connectList);
                },
            },
            {
                name: 'setEdid',
                regExp: /EDID\/(\d+)\/(\d+)\./i,
                callback: (match) => {
                    this.socket.send(`EDID/${match[1]}/${match[2]}`);
                },
            },
            {
                name: 'getVolumeMute',
                regExp: /%9923\./i,
                callback: (match) => {
                    this.socket.send(`${this.masterMute ? 'Master Mute.' : 'Master Unmute.'}`);
                },
            },
            {
                name: 'setVolumeMute',
                regExp: /Master(Mute|Unmute)\./i,
                callback: (match) => {
                    this.masterMute = match[1].toLowerCase() === 'mute' ? true : false;
                    this.socket.send(`${this.masterMute ? 'Master Mute.' : 'Master Unmute.'}`);
                },
            },
            {
                name: 'getVolume',
                regExp: /%9930\./i,
                callback: (match) => {
                    this.socket.send(`Volume of Master : ${this.masterVolume}`);
                },
            },
            {
                name: 'setVolume',
                regExp: /SetMasterVol:(\d+)\./i,
                callback: (match) => {
                    this.masterVolume = parseInt(match[1], 10);
                    this.socket.send(`Volume of Master : ${this.masterVolume}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /Status\s*(\d+)\./i,
                callback: (match) => {
                    if (match[1]) {
                        const output = parseInt(match[1], 10);
                        this.socket.send(`AV:${this.videoOutputs[output].padStart(2, '0')}->${match[1].padStart(2, '0')}`);
                    }
                    else {
                        this.socket.send(`CMD Error!`);
                    }
                },
            },
            {
                name: 'setRoute',
                regExp: /(\d+)V(\d+)\./i,
                callback: (match) => {
                    if (match[2]) {
                        const output = parseInt(match[2], 10);
                        this.videoOutputs[output] = match[1];
                        this.socket.send(`AV:${match[1].padStart(2, '0')}->${match[2].padStart(2, '0')}`);
                    }
                },
            },
            {
                name: 'setRoute',
                regExp: /(\d+)B(\d+)\./i,
                callback: (match) => {
                    if (match[2]) {
                        const output = parseInt(match[2], 10);
                        this.videoOutputs[output] = match[1];
                        this.socket.send(`${match[1]}B${match[2]}`);
                    }
                },
            },
            {
                name: 'powerSet',
                regExp: /(PWON|PWOFF|STANDBY)\./i,
                callback: (match) => {
                    this.power = match[1] === 'PWON' ? true : false;
                    this.socket.send(match[1]);
                },
            },
            {
                name: 'powerQuery',
                regExp: /%9962\./i,
                callback: (match) => {
                    this.socket.send(this.power ? 'PWON' : 'PWOFF');
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`CMD Error!`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a, _b;
        this.numberVideoInputs = Object.keys((_a = config === null || config === void 0 ? void 0 : config.videoInputs) !== null && _a !== void 0 ? _a : {}).length;
        this.numberVideoOutputs = Object.keys((_b = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _b !== void 0 ? _b : {}).length;
    }
}
Alfatron.emulatorType = 'socketEmulator';
Alfatron.key = '-MOXwaLNGaqzPZh3nEnK';
